import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { v4 as uuidv4 } from 'uuid';

/**
 * Store dla zarządzania tabelami (Metryczkami)
 */
const useTableStore = create(
  persist(
    (set, get) => ({
      tables: {}, // { id: { ...properties } }
      selectedTableId: null,
      isDraggingTable: false,
      isEditingTable: false,
      dragStartPos: null,

      // Default settings for new tables
      defaultSettings: {
        title: 'Metryczka',
        showTitle: true,
        x: 50,
        y: 50,
        columnWidth: 200, // Width of each column
        fontSize: 12,
        fontFamily: 'Inter',
        color: '#000000',
        backgroundColor: '#ffffff',
        showBorder: true,
        borderColor: '#000000',
        borderWidth: 1,
        padding: 8,
        data: [
          { id: '1', label: 'Rok budowy', value: '2024' },
          { id: '2', label: 'Inwestor', value: '-' },
          { id: '3', label: 'Powierzchnia użytkowa', value: '-' },
          { id: '4', label: 'Powierzchnia zabudowy', value: '-' },
          { id: '5', label: 'Kubatura', value: '-' }
        ]
      },

      // Actions
      addTable: (properties = {}) => {
        const id = uuidv4();
        const defaults = get().defaultSettings;
        // Merge defaults with provided properties
        const newTable = {
          id,
          x: properties.x !== undefined ? properties.x : defaults.x,
          y: properties.y !== undefined ? properties.y : defaults.y,
          title: properties.title || defaults.title,
          showTitle: properties.showTitle !== undefined ? properties.showTitle : defaults.showTitle,
          columnWidth: properties.columnWidth || defaults.columnWidth,
          fontSize: properties.fontSize || defaults.fontSize,
          fontFamily: properties.fontFamily || defaults.fontFamily,
          color: properties.color || defaults.color,
          backgroundColor: properties.backgroundColor || defaults.backgroundColor,
          showBorder: properties.showBorder !== undefined ? properties.showBorder : defaults.showBorder,
          borderColor: properties.borderColor || defaults.borderColor,
          borderWidth: properties.borderWidth || defaults.borderWidth,
          padding: properties.padding || defaults.padding,
          data: properties.data ? JSON.parse(JSON.stringify(properties.data)) : JSON.parse(JSON.stringify(defaults.data))
        };
        
        set((state) => ({ tables: { ...state.tables, [id]: newTable }, selectedTableId: id, isEditingTable: false }));
        return id;
      },
      removeTable: (id) => {
        set((state) => {
          const newTables = { ...state.tables };
          delete newTables[id];
          return { tables: newTables, selectedTableId: state.selectedTableId === id ? null : state.selectedTableId, isEditingTable: false };
        });
      },
      updateTable: (id, updates) => {
        set((state) => ({
          tables: { ...state.tables, [id]: { ...state.tables[id], ...updates } }
        }));
      },
      selectTable: (id) => {
        set({ selectedTableId: id, isEditingTable: false });
      },
      startEditingTable: (id) => {
        set({ selectedTableId: id, isEditingTable: true });
      },
      clearTableSelection: () => {
        set({ selectedTableId: null, isEditingTable: false });
      },

      // Dragging
      startDraggingTable: (id, startPos) => {
        set({ isDraggingTable: true, selectedTableId: id, dragStartPos: startPos });
      },
      updateDraggingTable: (newPos) => {
        const { isDraggingTable, selectedTableId } = get();
        if (!isDraggingTable || !selectedTableId) return;

        get().updateTable(selectedTableId, { x: newPos.x, y: newPos.y });
      },
      stopDraggingTable: () => {
        set({ isDraggingTable: false, dragStartPos: null });
      }
    }),
    {
      name: 'floorcraft-table-storage',
      partialize: (state) => ({ 
        tables: state.tables,
        defaultSettings: state.defaultSettings 
      }),
    }
  )
);

export default useTableStore;